/**
 * CompanyListHeader 컴포넌트 - 회사 선택 모달 헤더
 * (company-list/CompanyListHeader.tsx에서 통합됨)
 */

import { X, ChevronRight } from 'lucide-react';
import type { CompanyListTranslations } from './types';

interface CompanyListHeaderProps {
  showAddForm: boolean;
  t: CompanyListTranslations;
  onClose: () => void;
  onBack: () => void;
}

export function CompanyListHeader({
  showAddForm,
  t,
  onClose,
  onBack
}: CompanyListHeaderProps) {
  return (
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {showAddForm && (
            <button
              onClick={onBack}
              className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center"
            >
              <ChevronRight className="w-4 h-4 text-gray-400 rotate-180" />
            </button>
          )}
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {showAddForm ? t.addCompanyTitle : t.selectCompany}
            </h2>
            {!showAddForm && (
              <p className="text-sm text-gray-600">{t.selectForInvoice}</p>
            )}
          </div>
        </div>
        <button
          onClick={onClose}
          className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center"
        >
          <X className="w-4 h-4 text-gray-400" />
        </button>
      </div>
    </div>
  );
}
